import cx from 'classnames'
import styled from 'styled-components'

interface ContainerProps {
  overflowHidden?: boolean
  className?: string
}

interface ContentProps {
  scrollX: boolean
  scrollY: boolean
  scrollType?: string
  className?: string
}

export const Container = styled.div.attrs<ContainerProps>(
  ({ className, overflowHidden }) => ({
    className: cx(
      className,
      'tds-u-h-100',
      'tds-u-w-100',
      'tds-u-flex',
      'tds-u-flex-dir-col',
      overflowHidden ? 'tds-u-overflow-hidden' : 'tds-u-overflow-visible'
    )
  })
)<ContainerProps>``

export const CapItem = styled.div.attrs<{ className?: string }>(
  ({ className }) => ({
    className: cx(className)
  })
)`
  flex-shrink: 0;
  flex-grow: 0;
`

export const Content = styled.div<ContentProps>`
  flex: 1 1 auto;
  overflow-y: ${({ scrollY }) => (scrollY ? 'scroll' : 'hidden')};
  overflow-x: ${({ scrollX }) => (scrollX ? 'scroll' : 'hidden')};
`
